const comFloatNav = (() => {

  const jsFloatNav = (document.getElementById("jsFloatNav") != null);
  if (jsFloatNav) {



    let jsFloatNav = document.querySelector('#jsFloatNav');

    ScrollTrigger.create({
      trigger: 'body',
      start: "50px 0%",
      endTrigger: 'body',
      end: "100% 0%",
      toggleClass: { targets: jsFloatNav, className: "act" },
      // markers: true,
    });



  }
})()
export default comFloatNav;